export enum ECallbackPlace {
  HeadBlock = 'headblock',
  BlockStickyTop = 'blockStickytop',
  MortgageCalculator = 'mortgageCalculator',
}
